/**
 * customerAddressIsEditable reports whether customer addresses are mastered in
 * the GSM itself and may therefore be edited in the portal.
 *
 * This mirrors the backend environment variable CUSTOMERS_ONLY_LOCAL_QPM: only
 * the QPM-only deployment keeps customer addresses in its own database, where
 * PUT /customers/customer/address actually persists them. Every other
 * deployment reads them from Dynamics Sales, whose AddressService rejects PUT.
 * Keep VITE_CUSTOMER_ADDRESS_EDITABLE and CUSTOMERS_ONLY_LOCAL_QPM in sync when
 * a deployment changes.
 *
 * Defaults to false, so a deployment that forgets the variable shows the
 * address read-only instead of offering an edit that silently fails.
 */
export function customerAddressIsEditable(): boolean {
  return import.meta.env.VITE_CUSTOMER_ADDRESS_EDITABLE === "true";
}
